<template>
  <div>
      <div class="card" v-if="loadedMonthlyReport.length==0">
		
		<div class="card-body" >
			<h2 class="card-title skeleton">
				<!-- wating for title to load from javascript -->
			</h2>
			<p class="card-intro skeleton">
				<!-- waiting for intro to load from Javascript -->
			</p>
            <div class="card-img skeleton">
			<!-- waiting for img to load from javascript -->
		</div>
		</div>
	</div>
    
    <b-card v-else>
    
        <b-card-body  title="گزارش ماهانه از تعداد تراکنش ها و درگاهها">
          <hr class="my-10" />
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="تعداد کاربر جدید:"
                label-for="input-1"
              >
                <div class="form-control">
                  {{ loadedMonthlyReport.user_count }}
                </div>
              </b-form-group></b-col
            >
            <b-col>
              <b-form-group
                id="input-group-1"
                label="تعداد درگاه ریالی جدید:"
                label-for="input-1"
              >
                <div class="form-control">
                  {{ loadedMonthlyReport.peyment_gateway_ri }}
                </div>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="تعداد درگاه دلاری جدید:"
                label-for="input-1"
              >
                <div class="form-control">
                  {{ loadedMonthlyReport.peyment_gateway_dollar }}
                </div>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="تعداد درگاه های فعال به تعداد کل پذیرندگان:"
                label-for="input-1"
              >
                <div class="form-control">
                  {{ loadedMonthlyReport.gateways_on_usert }}
                </div>
              </b-form-group></b-col
            >
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="تعداد کل تراکنش ها(ریالی/دلاری):"
                label-for="input-1"
              >
                <div class="form-control">
                  {{ loadedMonthlyReport.transaction_count }}
                </div>
              </b-form-group></b-col
            >
            <b-col>
              <b-form-group
                id="input-group-1"
                label="مبلغ ریالی کل تراکنش ها:"
                label-for="input-1"
              >
                <div class="form-control">
                  {{
                    loadedMonthlyReport.transaction_sum != null
                      ? loadedMonthlyReport.transaction_sum.toLocaleString()
                      : 0
                  }}
                </div>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="میانگین تعداد تراکنش روزانه(ریالی/دلاری):"
                label-for="input-1"
              >
                <div class="form-control">
                  {{ loadedMonthlyReport.transaction_dayly_count_avg }}
                </div>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="میانگین مبلغ ریالی تراکنش های روزانه:"
                label-for="input-1"
              >
                <div class="form-control">
                  {{
                    loadedMonthlyReport.transaction_dayly_sum_avg != null
                      ? loadedMonthlyReport.transaction_dayly_sum_avg.toLocaleString()
                      : 0
                  }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="مینیمم تعداد تراکنش روزانه (ریالی/دلاری):"
                label-for="input-1"
              >
                <div class="form-control">
                  {{ loadedMonthlyReport.transaction_dayly_count_min }}
                </div>
              </b-form-group></b-col
            >
            <b-col>
              <b-form-group
                id="input-group-1"
                label="ماکسیمم تعداد تراکنش روزانه (ریالی/دلاری):"
                label-for="input-1"
              >
                <div class="form-control">
                  {{ loadedMonthlyReport.transaction_dayly_count_max }}
                </div>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="مینیمم مبلغ تراکنش روزانه (ریالی/دلاری):"
                label-for="input-1"
              >
                <div class="form-control">
                  {{
                    loadedMonthlyReport.transaction_dayly_sum_min != null
                      ? loadedMonthlyReport.transaction_dayly_sum_min.toLocaleString()
                      : 0
                  }}
                </div>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="ماکسیمم مبلغ تراکنش روزانه (ریالی/دلاری):"
                label-for="input-1"
              >
                <div class="form-control">
                  {{
                    loadedMonthlyReport.transaction_dayly_sum_max != null
                      ? loadedMonthlyReport.transaction_dayly_sum_max.toLocaleString()
                      : 0
                  }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row> </b-row>
        </b-card-body>
      
    </b-card>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_MONTHLY_REPRT } from "@/core/services/store/getMonthlyReport.module";

export default {
  name: "monthlyReport",
  data() {
    return {};
  },
  components: {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "گزارش ماهانه از تعداد تراکنش ها و درگاهها",
      },
    ]);
    this.$store.dispatch(GET_MONTHLY_REPRT);
  },
  computed: {
    loadedMonthlyReport() {
      return this.$store.getters.loadedMonthlyReport;
    },
  },
};
</script>
<style lang="scss" scoped>


*, *:after, *:before {
	box-sizing: border-box;
}

body {
	font-family: "Inter", sans-serif;
	background-color: #f2f5f7;
}

// THE CARD 
.card {
	display: flex;
	flex-direction: column;
	flex-basis: 300px;
	flex-shrink: 0;
	flex-grow: 0;
	max-width: 100%;
	background-color: #FFF;
	box-shadow: 0 5px 10px 0 rgba(#000, .15);
	border-radius: 10px;
	overflow: hidden;
	margin: 1rem;
}

.card-img {
	padding-bottom: 25%;
	position: relative;
	img {
		position: absolute;
		width: 100%;
	}
}

.card-body {
	padding: 1.5rem;
}

.card-title {
	font-size: 1.25rem;
	line-height: 1.33;
	font-weight: 700;
	&.skeleton { 
		min-height: 28px;
		border-radius: 4px;
	}
}

.card-intro {
	margin-top: .75rem;
	line-height: 1.5;
	&.skeleton { 
		min-height: 72px;
		border-radius: 4px;
	}
}

// THE LOADING EFFECT
.skeleton {
	background-color: #e2e5e7;
	
	background-image:			
			linear-gradient(
				90deg, 
				rgba(#fff, 0), 
				rgba(#fff, 0.5),
				rgba(#fff, 0)
			);
	background-size: 350px 100%; 
	background-repeat: no-repeat; 
	background-position: left -40px top 0; 
	animation: shine 1s ease infinite; 
}

@keyframes shine {
	to {
		
		background-position: right -40px top 0;
	}
}



.container {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
}
</style>
